import { IAddress, ILookUp } from "../models";
import moment from "moment";

const getInTouchTypes = [
    {id: 0, reason:"Please choose..." , desc : '' },
    {id: 1,reason:"Explore upgrade options" , desc : 'Would you like to look at alternative room types? Business class flights? Full board?' },
    {id: 2,reason:"Special requests" , desc : 'Let us know what we can arrange for you, for example babysitting, restaurant reservations, tennis, golf, spa treatments' },
    {id: 3,reason:"Request new quote" , desc : '' },
    {id: 4,reason:"Request amendment to holiday" , desc : 'Would you like to change who is travelling, change the length of your holiday, amend the itinerary or change the dates of travel?' },
    // {id: 3,reason:"Provide outstanding information" , desc : 'For example, have you made your own travel arrangements?' },
    {id:5,reason:"Reactivate expired holiday" , desc : 'This will send a request to your travel consultant so they can re-quote your holiday. Please let us know if you would like to make any changes.' },

  
    {id: 6,reason:"Cancel my holiday" , desc : 'I would like to cancel my holiday and by doing so send written confirmation to my travel consultant that this is my intention. I understand that services that have been previously held may be released and that my travel consultant will contact me as soon as possible to discuss the cancellation terms and options available to me.' }
];

export const GetInTouchOptions = (): Array<ILookUp> => {
    return getInTouchTypes.map((c) => ({ id: c.id, title: c.reason }));
}

export const GetGetInTouchReasonDesc = (reason: string): string => {
    const type = getInTouchTypes.find(g => g.reason === reason);
    return type ? type.desc : '';
}

export const getReasonByType = (type: string): ILookUp => {
    let reason = "";
    let id = 0;
    switch (type) {
        case "NewQuote":
            reason = "Request new quote";
            id = 3;
            break;
        case "Amend":
            reason = "Request amendment to holiday";
            id = 4;
            break;
        case "Requote":
            reason = "Request amendment to holiday";
            id = 4;
            break;
        case "RequestConcierge":
            reason = "Special requests";
            id = 2;
            break;
        case "Cancel":
            reason = "Cancel my holiday";
            id = 6;
            break;
    }
    return { id: id, title: reason };
}

export const TitleOptions: Array<ILookUp> = [
    {id:1,title:"Mr"},{id:2,title:"Mrs"},
    {id:4,title:"Dr"},{id:6,title:"Master"},
    {id:7,title:"Sir"},{id:8,title:"Mr & Mrs"},
    {id:9,title:"Lord"},{id:10,title:"Miss"},
    {id:11,title:"Mr(s)"},{id:12,title:"Ms"},
    {id:13,title:"Prof"},{id:14,title:"Lady"},
    {id:15,title:"Madam"},{id:16,title:"Baron"},
    {id:17,title:"Rabbi"}
]

export const CountryOptions: Array<ILookUp> =
    [{ id: 1, title: "Afghanistan" }, { id: 3, title: "Albania" },
    { id: 4, title: "Algeria" }, { id: 6, title: "Andorra" },
    { id: 7, title: "Angola" }, { id: 8, title: "Anguilla" },
    { id: 10, title: "Antigua and Barbuda" }, { id: 11, title: "Argentina" },
    { id: 12, title: "Armenia" }, { id: 13, title: "Aruba" },
    { id: 14, title: "Australia" }, { id: 15, title: "Austria" },
    { id: 16, title: "Azerbaijan" }, { id: 17, title: "Bahamas" },
    { id: 18, title: "Bahrain" }, { id: 19, title: "Bangladesh" },
    { id: 20, title: "Barbados" }, { id: 21, title: "Belarus" },
    { id: 22, title: "Belgium" }, { id: 23, title: "Belize" },
    { id: 24, title: "Benin" }, { id: 25, title: "Bermuda" },
    { id: 26, title: "Bhutan" }, { id: 27, title: "Bolivia" },
    { id: 28, title: "Bosnia and Herzegovina" }, { id: 29, title: "Botswana" },
    { id: 30, title: "Bouvet Island" }, { id: 31, title: "Brazil" },
    { id: 32, title: "British Indian Ocean Territory" }, { id: 33, title: "British Virgin Islands" },
    { id: 34, title: "Brunei Darussalam" }, { id: 35, title: "Bulgaria" },
    { id: 36, title: "Burkina Faso" }, { id: 37, title: "Burundi" },
    { id: 38, title: "Cambodia" }, { id: 39, title: "Cameroon" },
    { id: 40, title: "Canada" }, { id: 41, title: "Cape Verde Islands" },
    { id: 42, title: "Cayman Islands" }, { id: 43, title: "Central African Republic" },
    { id: 44, title: "Chad" }, { id: 45, title: "Chile" },
    { id: 46, title: "China" }, { id: 47, title: "Christmas Island" },
    { id: 48, title: "Cocos Islands" }, { id: 49, title: "Colombia" },
    { id: 50, title: "Comoros" }, { id: 51, title: "Congo" },
    { id: 52, title: "Cook Islands" }, { id: 53, title: "Costa Rica" },
    { id: 54, title: "Croatia" }, { id: 55, title: "Cuba" },
    { id: 56, title: "Cyprus" }, { id: 57, title: "Czech Republic" },
    { id: 58, title: "D.R.Congo" }, { id: 59, title: "Denmark" },
    { id: 60, title: "Djibouti" }, { id: 61, title: "Dominica" },
    { id: 62, title: "Dominican Republic" }, { id: 151, title: "Dutch Antilles" },
    { id: 63, title: "Ecuador" }, { id: 64, title: "Egypt" },
    { id: 65, title: "Eire" }, { id: 66, title: "El Salvador" },
    { id: 67, title: "Equatorial Guinea" }, { id: 68, title: "Eritrea" },
    { id: 69, title: "Estonia" }, { id: 70, title: "Ethiopia" },
    { id: 71, title: "Falkland Islands" }, { id: 72, title: "Faroe Islands" },
    { id: 73, title: "Fiji" }, { id: 74, title: "Finland" },
    { id: 75, title: "France" }, { id: 76, title: "French Guiana" },
    { id: 77, title: "French Polynesia" }, { id: 79, title: "Gabon" },
    { id: 80, title: "Gambia" }, { id: 81, title: "Georgia" },
    { id: 82, title: "Germany" }, { id: 83, title: "Ghana" },
    { id: 84, title: "Gibraltar" }, { id: 85, title: "Greece" },
    { id: 86, title: "Greenland" }, { id: 87, title: "Grenada" },
    { id: 89, title: "Guam" }, { id: 90, title: "Guatemala" },
    { id: 91, title: "Guinea" }, { id: 92, title: "Guinea - Bissau" },
    { id: 93, title: "Guyana" }, { id: 94, title: "Haiti" },
    { id: 96, title: "Honduras" }, { id: 97, title: "Hong Kong" },
    { id: 98, title: "Hungary" }, { id: 99, title: "Iceland" },
    { id: 100, title: "India" }, { id: 101, title: "Indonesia" },
    { id: 102, title: "Iran" }, { id: 103, title: "Iraq" },
    { id: 104, title: "Israel" }, { id: 105, title: "Italy" },
    { id: 106, title: "Ivory Coast" }, { id: 107, title: "Jamaica" },
    { id: 108, title: "Japan" }, { id: 109, title: "Jordan" },
    { id: 110, title: "Kazakhstan" }, { id: 111, title: "Kenya" },
    { id: 112, title: "Kirghizstan" }, { id: 113, title: "Kiribati" },
    { id: 114, title: "Kuwait" }, { id: 115, title: "Laos" },
    { id: 116, title: "Latvia" }, { id: 117, title: "Lebanon" },
    { id: 118, title: "Lesotho" }, { id: 119, title: "Liberia" },
    { id: 120, title: "Libya" }, { id: 121, title: "Liechtenstein" },
    { id: 122, title: "Lithuania" }, { id: 123, title: "Luxembourg" },
    { id: 124, title: "Macau" }, { id: 125, title: "Macedonia" },
    { id: 126, title: "Madagascar" }, { id: 127, title: "Malawi" },
    { id: 128, title: "Malaysia" }, { id: 129, title: "Maldives" },
    { id: 130, title: "Mali" }, { id: 131, title: "Malta" },
    { id: 134, title: "Martinique" }, { id: 135, title: "Mauritania" },
    { id: 136, title: "Mauritius" }, { id: 138, title: "Mexico" },
    { id: 139, title: "Micronesia" }, { id: 140, title: "Moldova" },
    { id: 141, title: "Monaco" }, { id: 142, title: "Mongolia" },
    { id: 241, title: "Montenegro" }, { id: 143, title: "Montserrat" },
    { id: 144, title: "Morocco" }, { id: 145, title: "Mozambique" },
    { id: 146, title: "Myanmar" }, { id: 147, title: "Namibia" },
    { id: 148, title: "Nauru" }, { id: 149, title: "Nepal" }, { id: 150, title: "Netherlands" },
    { id: 152, title: "New Caledonia" }, { id: 153, title: "New Zealand" },
    { id: 154, title: "Nicaragua" }, { id: 155, title: "Niger" },
    { id: 156, title: "Nigeria" }, { id: 157, title: "Niue" },
    { id: 159, title: "North Korea" }, { id: 161, title: "Norway" },
    { id: 162, title: "Oman" }, { id: 163, title: "Pakistan" },
    { id: 164, title: "Palau" }, { id: 165, title: "Panama" },
    { id: 166, title: "Papua New Guinea" }, { id: 167, title: "Paraguay" },
    { id: 168, title: "Peru" }, { id: 169, title: "Philippines" },
    { id: 171, title: "Poland" }, { id: 172, title: "Portugal" },
    { id: 173, title: "Puerto Rico" }, { id: 174, title: "Qatar" },
    { id: 176, title: "Reunion" }, { id: 177, title: "Romania" },
    { id: 178, title: "Russia" }, { id: 179, title: "Rwanda" },
    { id: 180, title: "Samoa" }, { id: 181, title: "San Marino" },
    { id: 182, title: "Sao Tome and Principe" }, { id: 183, title: "Saudi Arabia" },
    { id: 184, title: "Senegal" }, { id: 185, title: "Serbia" }, { id: 186, title: "Seychelles" },
    { id: 187, title: "Sierra Leone" }, { id: 188, title: "Singapore" },
    { id: 189, title: "Slovakia" }, { id: 190, title: "Slovenia" },
    { id: 191, title: "Solomon Islands" }, { id: 192, title: "Somalia" },
    { id: 193, title: "South Africa" }, { id: 194, title: "South Georgia" },
    { id: 195, title: "South Korea" }, { id: 196, title: "Spain" },
    { id: 197, title: "Sri Lanka" }, { id: 88, title: "St Barts, St Martin and Guadaloupe" },
    { id: 199, title: "St Kitts and Nevis" }, { id: 200, title: "St Lucia" },
    { id: 202, title: "St Vincent, Mustique  and the Grenadines" },
    { id: 203, title: "Sudan" }, { id: 204, title: "Suriname" },
    { id: 206, title: "Swaziland" }, { id: 207, title: "Sweden" },
    { id: 208, title: "Switzerland" }, { id: 209, title: "Syria" },
    { id: 210, title: "Tadjikistan" }, { id: 211, title: "Taiwan" },
    { id: 212, title: "Tanzania" }, { id: 213, title: "Thailand" },
    { id: 214, title: "Tibet" }, { id: 216, title: "Togo" },
    { id: 218, title: "Tonga" }, { id: 219, title: "Trinidad and Tobago" },
    { id: 220, title: "Tunisia" }, { id: 221, title: "Turkey" },
    { id: 222, title: "Turkmenistan" }, { id: 223, title: "Turks and Caicos Islands" },
    { id: 225, title: "Uganda" }, { id: 226, title: "Ukraine" },
    { id: 227, title: "United Arab Emirates" }, { id: 228, title: "United Kingdom" },
    { id: 230, title: "United States of America" }, { id: 229, title: "Uruguay" },
    { id: 231, title: "Uzbekistan" }, { id: 232, title: "Vanuatu" },
    { id: 233, title: "Vatican City" }, { id: 234, title: "Venezuela" },
    { id: 235, title: "Vietnam" }, { id: 236, title: "Virgin Islands" },
    { id: 238, title: "Yemen" }, { id: 239, title: "Zambia" },
    { id: 240, title: "Zimbabwe" }];


export const HolidayInterests: Array<ILookUp> = [
    { id: 31, title: 'I do not know where but I know when' },
    { id: 8, title: 'Africa & Safari' },
    { id: 30, title: 'Asia & Australasia' },
    { id: 12, title: 'Europe' },
    { id: 13, title: 'Indian Ocean & Caribbean' },
    { id: 29, title: 'Indian Subcontinent & Arabia tours' },
    { id: 7, title: 'Hotels with Explorers kids club' },
    { id: 26, title: 'Middle East resorts' },
    { id: 15, title: 'Ski' },
    { id: 9, title: 'South and Central America & Antarctica' },
    { id: 18, title: 'USA & Canada tours' }
];

export const EnquiryNoOfPeople = (): Array<string> => {
    return Array.from(Array(11).keys()).filter(a => a > 0).map(a => a.toString());
};

export const GetMonthNames = (): Array<ILookUp> => {
    return Array.from(Array(13).keys()).filter(a => a > 0).map(function (a) { return { id: a, title: moment(a, 'M').format('MMMM') } });
};

export const GetFutureYears = (numberOfYears: number): Array<number> => {
    const currentYear = moment().year();
    return Array.from(Array(numberOfYears).keys()).map((x, i) => currentYear + i); 
};

export const BookedBookingSubStatus = () : Array<number> =>{
    return [28,29,30,31,32,35,36,37,38,39,40,41,42];
}

export const HolidayBudgets: Array<ILookUp> = [
    { id: 19, title: "<3k" },
    { id: 9, title: "3-5k" },
    { id: 10, title: "6-10k" },
    { id: 11, title: "11-15k" },
    { id: 12, title: "16-20k" },
    { id: 13, title: "21-30k" },
    { id: 14, title: "31-40k" },
    { id: 15, title: "41-50k" },
    { id: 16, title: "51-70k" },
    { id: 17, title: "71-100k" },
    { id: 18, title: "101-125k" },
    { id: 20, title: "126-150k" },
    { id: 21, title: "151-175k" },
    { id: 22, title: "176-200k" },
    { id: 23, title: "200k+" }
];

export const Relationships : Array<ILookUp> = [
    { id: 19, title: "Main"},
    { id: 23, title: "Partner" },
    { id: 25, title: "Husband" },
    { id: 26, title: "Wife" },
    { id: 17, title: "Child" },
    { id: 18, title: "Grand Parent" },
    { id: 22, title: "Other Family" },
    { id: 20, title: "Nanny" },
    { id: 21, title: "Non Family"},
    { id: 24, title: "Unknown"}
];

export const FrequentFlyer : Array<ILookUp> =[
    {id:1,title:"British Airways Blue"},
    {id:2,title:"British Airways Silver"},
    {id:3,title:"Virgin Atlantic "},
    {id:4,title:"BMI "},
    {id:5,title:"British Airways Gold"},
    {id:6,title:"British Airways Premier"},
    {id:7,title:"Star Alliance"},
    {id:8,title:"One World"},
    {id:9,title:"Victor Alto Membership"}
];

export const SeatPreference : Array <ILookUp> =[
    {id:1,title:"Window"},
    {id:2,title:"Aisle"}
];

export const AboutUsText = (): string => {
    return "<p>At Scott Dunn, we live and breathe travel. An insatiable appetite to discover the world runs through every member of our team. The brand was first established over three decades ago, born out of a desire to revolutionise ski holidays for the luxury market. Since then, we’ve expanded to cover all seven continents, and continue to offer high-end holidays with an adventurous edge, whether that's a remote safari lodge in the Okavango Delta or an expedition cruise in Antarctica.</p><p>Our specialists have travelled to the farthest reaches of the world, exploring everything from the biggest cities to the smallest rural villages, from vast rainforests to tiny desert islands. Our mission is simple – to use the in-depth knowledge that we’ve built up from innumerable journeys round the globe to instil in our guests a love of travel as voracious as our own. Our experts work in small teams that specialise in geographical areas, allowing them to get to know their destinations inside out, from the most authentic experiences to the hottest hotels (and everything in between). And we’re meticulous about detail. We know that it’s often the smallest touches that make the biggest difference, and we’ll stop at nothing to make every trip not only exceptional but totally unique </p><p>We champion diversity in all forms. We are signatories of both the Race at Work Charter and the Diversity in Hospitality, Travel and Leisure Charter, which are part of our continued commitment to promote equality in our workplace and beyond. In recent years, both our CEO Sonia Davies and our Head of Integrated Marketing have been recognised as Women to Watch in Hospitality, Travel and Leisure. With offices in London, California and Singapore, we are a growing global business, but our team is close-knit. It’s our people that set us apart – passionate, honest and absolutely dedicated to our guests. But don’t just take our word for it; we have been voted Condé Nast Traveller’s Top Travel Specialist in the World eight years in a row.</p> ";
}

export const GetPhoneNumber = (businessUnitId: number) =>{
    if(businessUnitId === 2)
    {
        return  "(858) 927-8022";
    }
    if(businessUnitId === 3)
    {
        return "65 3165 4050";
    }
    return "020 3993 8860";
}

export const GetAddressLineForApexx = (address: IAddress) => {
    let addressLine = address.address1 ? address.address1 : '';
    if (address.address2 && address.address2.length > 0) {
        if (addressLine.length > 0) addressLine = addressLine + ', ';
        addressLine = addressLine + address.address2;
    }
    return addressLine;
}